<!-- t(common.isRequired) -->
<span class="form-error"> {{ message || ('common.isRequired' | transloco) }}</span>
